export default __webpack_public_path__ + "static/media/folder-close-on.31d98272.svg";